import {
  EXPORT_ZIP_FORM_FIELD_CHATS_FILES_PRIVATE,
  EXPORT_ZIP_FORM_FIELD_CHATS_FILES_PUBLIC,
  EXPORT_ZIP_FORM_FIELD_CHATS_TEXT_ONLY_PRIVATE,
  EXPORT_ZIP_FORM_FIELD_CHATS_TEXT_ONLY_PUBLIC,
} from '../RequestExportEmailsFilesChatsModal.constants'

function checkIsPublic(field) {
  return (
    field.field_id === EXPORT_ZIP_FORM_FIELD_CHATS_TEXT_ONLY_PUBLIC ||
    field.field_id === EXPORT_ZIP_FORM_FIELD_CHATS_FILES_PUBLIC
  )
}

function checkIsChatsFilesPrivate(field) {
  return field.field_id === EXPORT_ZIP_FORM_FIELD_CHATS_FILES_PRIVATE
}

export function fillFormikValuesFromFieldList(fieldIds, value) {
  return fieldIds.reduce((acc, id) => {
    acc[id] = value

    return acc
  }, {})
}

export function checkIsChatsTextOnlyPrivate(field) {
  return field.field_id === EXPORT_ZIP_FORM_FIELD_CHATS_TEXT_ONLY_PRIVATE
}

export function checkIsPrivate(field) {
  return checkIsChatsFilesPrivate(field) || checkIsChatsTextOnlyPrivate(field)
}

export function checkIsChild(field) {
  return checkIsPrivate(field) || checkIsPublic(field)
}
